export default __webpack_public_path__ + "static/media/gallery-spectrespecs_01.fb023fa1.jpg";